import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { submitFeedback } from './contact-us.api';
import { FeedbackPayload } from './contact-us.type';

export const useSubmitFeedbackMutation = () => {
  return useMutation({
    mutationFn: (data: FeedbackPayload) => submitFeedback(data),
    onSuccess: () => {
      toast.success('Feedback submitted successfully');
    },
    onError: () => {
      toast.error('Failed to submit feedback');
    },
  });
};
